import React, {useCallback} from 'react';

import {SequenceSummary} from 'constants/SequenceConstants';
import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';

export default function SequenceAnalysisPreview(props: PreviewProps): JSX.Element {
  const {item} = props;
  const renderItem = useCallback(() => {
    // @ts-expect-error(2322)
    const sequence: SequenceSummary = item;
    return (
      <div className="note-preview-body">
        <img src={sequence.snapshot_url} />
      </div>
    );
  }, [item]);
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-sequence',
    noteType: NoteConstants.SEQUENCE,
    renderItem,
  });

  return render();
}
